import { Breadcrumb } from 'antd';
import React from 'react';

const ThinktankrAddresss: React.FC = () => (
  <Breadcrumb style={{fontSize:'16px',marginBottom:'11px'}} separator=">">
       <Breadcrumb.Item> {localStorage.getItem("i18nextLng") === 'zh-HK' ? '主頁' :'主页'}</Breadcrumb.Item>
    <Breadcrumb.Item>  {localStorage.getItem("i18nextLng") === 'zh-HK' ? '關於我們' :'关于我们'}</Breadcrumb.Item>
    <Breadcrumb.Item>  {localStorage.getItem("i18nextLng") === 'zh-HK' ? '成員簡介' :'成员简介'}</Breadcrumb.Item>
  </Breadcrumb>
);

export default ThinktankrAddresss;